var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',{attrs:{"include":_vm.include}},[_c('router-view',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.title),expression:"title"}],attrs:{"img-set":"/favicon.ico"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }